import { render } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=6396cac9"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6396cac9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6396cac9', script)) {
    api.reload('6396cac9', script)
  }
  
  module.hot.accept("./TwoFactorAuthenticationForm.vue?vue&type=template&id=6396cac9", () => {
    api.rerender('6396cac9', render)
  })

}

script.__file = "resources/js/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue"

export default script